// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { handleUnauthorized } from '../../TokenAuth/auth';
// const BASE_URL = process.env.REACT_APP_BASEURL;



// const initialState = {
//     giftAmounts: [],
//     status: 'idle',
//     error: null,
// };
// const getAuthToken = () => localStorage.getItem("vedhvidhi-admin-token");
// export const fetchGiftAmounts = createAsyncThunk(
//     'giftAmount/fetchGiftAmounts',
//     async (_, { rejectWithValue }) => {
//         try {
//             const response = await fetch(`${BASE_URL}/admin/giftAmount`, {
//                 headers: {
//                     'Authorization': getAuthToken(),
//                 },
//             });
//             if (!response.ok) throw new Error('Failed to fetch gift amounts');
//              if (response.status === 401) {  
//                 handleUnauthorized();
//                 throw new Error("Unauthorized: Please login again");
//             }
//             const data = await response.json();
//             return data?.data;
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );
// export const postGiftAmount = createAsyncThunk(
//     'giftAmount/postGiftAmount',
//     async (giftAmountsArray, { rejectWithValue }) => {
//         try {
//             const response = await fetch(`${BASE_URL}/admin/giftAmount`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': getAuthToken(),
//                 },
//                 body: JSON.stringify(giftAmountsArray),
//             });
//             if (!response.ok) throw new Error('Failed to add gift amounts');
//             const data = await response.json();
//             return data?.data;
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

// // 3. Update Multiple Gift Amounts (PATCH)
// export const updateGiftAmount = createAsyncThunk(
//     'giftAmount/updateGiftAmount',
//     async ({ id, giftAmountsArray }, { rejectWithValue }) => {
//         try {
//             const response = await fetch(`${BASE_URL}/admin/giftAmount/${id}`, {
//                 method: 'PATCH',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': getAuthToken(),
//                 },
//                 body: JSON.stringify(giftAmountsArray),
//             });
//             if (!response.ok) throw new Error('Failed to update multiple gift amounts');
//             const data = await response.json();
//             return data?.data;
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

// // 4. Delete Gift Amount (DELETE)
// export const deleteGiftAmount = createAsyncThunk(
//     'giftAmount/deleteGiftAmount',
//     async (id, { rejectWithValue }) => {
//         try {
//             const response = await fetch(`${BASE_URL}/admin/giftAmount/${id}`, {
//                 method: 'DELETE',
//                 headers: {
//                     'Authorization': getAuthToken(),
//                 },
//             });
//             if (!response.ok) throw new Error('Failed to delete gift amount');
//             return id;
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

// // ==============================
// // Slice
// // ==============================

// const giftAmountSlice = createSlice({
//     name: 'giftAmount',
//     initialState,
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             // Fetch
//             .addCase(fetchGiftAmounts.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(fetchGiftAmounts.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 state.giftAmounts = action.payload;
//             })
//             .addCase(fetchGiftAmounts.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             })

//             // Add
//             .addCase(postGiftAmount.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(postGiftAmount.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 state.giftAmounts = [...state.giftAmounts, ...action.payload];
//             })
//             .addCase(postGiftAmount.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             })

//             // Update Multiple
//             .addCase(updateGiftAmount.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(updateGiftAmount.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 const updatedItems = action.payload;
//                 updatedItems.forEach(updated => {
//                     const index = state.giftAmounts.findIndex(g => g._id === updated._id);
//                     if (index !== -1) {
//                         state.giftAmounts[index] = updated;
//                     }
//                 });
//             })
//             .addCase(updateGiftAmount.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             })

//             // Delete
//             .addCase(deleteGiftAmount.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(deleteGiftAmount.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 state.giftAmounts = state.giftAmounts.filter(g => g._id !== action.payload);
//             })
//             .addCase(deleteGiftAmount.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             });
//     },
// });

// export default giftAmountSlice.reducer;

// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { handleUnauthorized } from '../../TokenAuth/auth';
// const BASE_URL = process.env.REACT_APP_BASEURL;

// const initialState = {
//     giftAmounts: [],
//     status: 'idle',
//     error: null,
//     paginationDetail: { totalDocs: 0, totalPages: 0, page: 1, limit: 10 }, // ✅ added
// };

// const getAuthToken = () => localStorage.getItem("vedhvidhi-admin-token");

// export const fetchGiftAmounts = createAsyncThunk(
//     'giftAmount/fetchGiftAmounts',
//     async ({ page = 1, limit = 10 } = {}, { rejectWithValue }) => {   // ✅ added args
//         try {
//             const response = await fetch(
//                 `${BASE_URL}/admin/giftAmount?page=${page}&limit=${limit}`, // ✅ with pagination
//                 {
//                     headers: {
//                         'Authorization': getAuthToken(),
//                     },
//                 }
//             );
//             if (!response.ok) throw new Error('Failed to fetch gift amounts');
//             if (response.status === 401) {
//                 handleUnauthorized();
//                 throw new Error("Unauthorized: Please login again");
//             }
//             const data = await response.json();
//             return {
//                 giftAmounts: data?.data || [],
//                 paginationDetail: data?.paginationDetail || { totalDocs: 0, totalPages: 0, page, limit }, // ✅ added
//             };
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

// export const postGiftAmount = createAsyncThunk(
//     'giftAmount/postGiftAmount',
//     async (giftAmountsArray, { rejectWithValue }) => {
//         try {
//             const response = await fetch(`${BASE_URL}/admin/giftAmount`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': getAuthToken(),
//                 },
//                 body: JSON.stringify(giftAmountsArray),
//             });
//             if (!response.ok) throw new Error('Failed to add gift amounts');
//             const data = await response.json();
//             return data?.data;
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

// // 3. Update Multiple Gift Amounts (PATCH)
// export const updateGiftAmount = createAsyncThunk(
//     'giftAmount/updateGiftAmount',
//     async ({ id, giftAmountsArray }, { rejectWithValue }) => {
//         try {
//             const response = await fetch(`${BASE_URL}/admin/giftAmount/${id}`, {
//                 method: 'PATCH',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     'Authorization': getAuthToken(),
//                 },
//                 body: JSON.stringify(giftAmountsArray),
//             });
//             if (!response.ok) throw new Error('Failed to update multiple gift amounts');
//             const data = await response.json();
//             return data?.data;
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

// // 4. Delete Gift Amount (DELETE)
// export const deleteGiftAmount = createAsyncThunk(
//     'giftAmount/deleteGiftAmount',
//     async (id, { rejectWithValue }) => {
//         try {
//             const response = await fetch(`${BASE_URL}/admin/giftAmount/${id}`, {
//                 method: 'DELETE',
//                 headers: {
//                     'Authorization': getAuthToken(),
//                 },
//             });
//             if (!response.ok) throw new Error('Failed to delete gift amount');
//             return id;
//         } catch (error) {
//             return rejectWithValue(error.message);
//         }
//     }
// );

// // ==============================
// // Slice
// // ==============================

// const giftAmountSlice = createSlice({
//     name: 'giftAmount',
//     initialState,
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             // Fetch
//             .addCase(fetchGiftAmounts.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(fetchGiftAmounts.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 state.giftAmounts = action.payload.giftAmounts;   // ✅ updated
//                 state.paginationDetail = action.payload.paginationDetail; // ✅ added
//             })
//             .addCase(fetchGiftAmounts.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             })

//             // Add
//             .addCase(postGiftAmount.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(postGiftAmount.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 state.giftAmounts = [...state.giftAmounts, ...action.payload];
//             })
//             .addCase(postGiftAmount.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             })

//             // Update Multiple
//             .addCase(updateGiftAmount.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(updateGiftAmount.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 const updatedItems = action.payload;
//                 updatedItems.forEach(updated => {
//                     const index = state.giftAmounts.findIndex(g => g._id === updated._id);
//                     if (index !== -1) {
//                         state.giftAmounts[index] = updated;
//                     }
//                 });
//             })
//             .addCase(updateGiftAmount.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             })

//             // Delete
//             .addCase(deleteGiftAmount.pending, (state) => {
//                 state.status = 'loading';
//             })
//             .addCase(deleteGiftAmount.fulfilled, (state, action) => {
//                 state.status = 'succeeded';
//                 state.giftAmounts = state.giftAmounts.filter(g => g._id !== action.payload);
//             })
//             .addCase(deleteGiftAmount.rejected, (state, action) => {
//                 state.status = 'failed';
//                 state.error = action.payload;
//             });
//     },
// });

// export default giftAmountSlice.reducer;


import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { handleUnauthorized } from '../../TokenAuth/auth';

const BASE_URL = process.env.REACT_APP_BASEURL;


const initialState = {
  giftAmounts: [],
  status: 'idle',
  error: null,
  paginationDetail: { totalDocs: 0, totalPages: 0, page: 1, limit: 10 },
};


const getAuthToken = () => localStorage.getItem('vedhvidhi-admin-token');


export const fetchGiftAmounts = createAsyncThunk(
  'giftAmount/fetchGiftAmounts',
  async ({ page = 1, limit = 10, category } = {}, { rejectWithValue }) => {
    try {
      let url = `${BASE_URL}/admin/giftAmount?page=${page}&limit=${limit}`;

      // ✅ Add category filter if not 'All'
      if (category && category !== 'All') {
        url += `&category=${encodeURIComponent(category)}`;
      }

      const response = await fetch(url, {
        headers: { Authorization: getAuthToken() },
      });

      if (response.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized: Please login again');
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Failed to fetch gift amounts');
      }

      const data = await response.json();

      return {
        giftAmounts: data?.data || [],
        paginationDetail:
          data?.paginationDetail || { totalDocs: 0, totalPages: 0, page, limit },
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Fetch failed');
    }
  }
);

// ==============================
// 2. Add New Gift Amount(s)
// ==============================
export const postGiftAmount = createAsyncThunk(
  'giftAmount/postGiftAmount',
  async (giftAmountsArray, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/admin/giftAmount`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getAuthToken(),
        },
        body: JSON.stringify(giftAmountsArray),
      });

      if (response.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized: Please login again');
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Failed to add gift amounts');
      }

      const data = await response.json();
      return data?.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ==============================
// 3. Update Gift Amount
// ==============================
export const updateGiftAmount = createAsyncThunk(
  'giftAmount/updateGiftAmount',
  async ({ id, giftAmountsArray }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/admin/giftAmount/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: getAuthToken(),
        },
        body: JSON.stringify(giftAmountsArray),
      });

      if (response.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized: Please login again');
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Failed to update gift amount');
      }

      const data = await response.json();
      return data?.data || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ==============================
// 4. Delete Gift Amount
// ==============================
export const deleteGiftAmount = createAsyncThunk(
  'giftAmount/deleteGiftAmount',
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}/admin/giftAmount/${id}`, {
        method: 'DELETE',
        headers: { Authorization: getAuthToken() },
      });

      if (response.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized: Please login again');
      }

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Failed to delete gift amount');
      }

      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ==============================
// Slice Definition
// ==============================
const consultationSlice = createSlice({
  name: 'ConsultationReducer',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchGiftAmounts.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchGiftAmounts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.giftAmounts = action.payload.giftAmounts;
        state.paginationDetail = action.payload.paginationDetail;
        state.error = null;
      })
      .addCase(fetchGiftAmounts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Post
      .addCase(postGiftAmount.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(postGiftAmount.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.giftAmounts = [...state.giftAmounts, ...action.payload];
      })
      .addCase(postGiftAmount.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Update
      .addCase(updateGiftAmount.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateGiftAmount.fulfilled, (state, action) => {
        state.status = 'succeeded';
        const updatedItems = action.payload;
        updatedItems.forEach((updated) => {
          const index = state.giftAmounts.findIndex((g) => g._id === updated._id);
          if (index !== -1) state.giftAmounts[index] = updated;
        });
      })
      .addCase(updateGiftAmount.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Delete
      .addCase(deleteGiftAmount.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteGiftAmount.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.giftAmounts = state.giftAmounts.filter(
          (g) => g._id !== action.payload
        );
      })
      .addCase(deleteGiftAmount.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default consultationSlice.reducer;

